import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiError} from './useHandleApiError';

type IOptions<T> = {
   onSuccess?: (data: T) => void;
   onFailure?: (error: any) => void;
};

export function usePutApi<T = any>(url: string, options?: IOptions<T>) {
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<T>();

   const handleError = useHandleApiError({
      url,
      setError,
      setLoading,
   });

   const request = React.useCallback(
      (body: BodyInit, searchParams?: Record<string, string> | null, _options?: IOptions<T>) => {
         let _url = url;

         if (searchParams) {
            _url = `${_url}?${new URLSearchParams(searchParams)}`;
         }
         setLoading(true);
         setState(undefined);
         ApiService.putSecureJson(_url, body)
            .then((res) => {
               return res.json().catch(() => res);
            })
            .then((data: T) => {
               setState(data);
               setLoading(false);
               (options || _options)?.onSuccess?.(data);
            })
            .catch(handleError((options || _options)?.onFailure));
      },
      [handleError, options, setLoading, setState, url]
   );
   return {request, state, loading, error};
}
